import { __assign, __rest } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { Keys } from '../../../lib/keyboard';
import { cnButton } from '../Button';
/**
 * @param {IButtonTypeLinkProps} props
 */
export var withTypeLink = withBemMod(cnButton(), { type: 'link' }, function (WrappedComponent) {
    return function (_a) {
        var type = _a.type, target = _a.target, rel = _a.rel, url = _a.url, disabled = _a.disabled, tabIndex = _a.tabIndex, props = __rest(_a, ["type", "target", "rel", "url", "disabled", "tabIndex"]);
        var relationship = rel;
        if (target === '_blank' && rel !== undefined && rel.indexOf('noopener') === -1) {
            // Пользовательский атрибут имеет больший приоритет
            relationship = rel + " noopener";
        }
        return (React.createElement(WrappedComponent, __assign({}, props, { rel: relationship, target: target, disabled: disabled, pressKeys: [Keys.ENTER], href: disabled ? undefined : url, tabIndex: disabled ? -1 : tabIndex, 
            // @ts-ignore (TODO: https://st.yandex-team.ru/ISL-5854)
            type: null, 
            // @ts-ignore (TODO: https://st.yandex-team.ru/ISL-5854)
            autoComplete: null, as: "a" })));
    };
});
